export interface IQuyTrinhXuLy{
    Id:number,
    IdSanPham:number,
    Ten:string,
    NoiDungXuLy:string,
    TrangThai:number,
    IdCoQuan:number,
    TrangThaiApDung:number,
    NangCap:number,
    NangCapN:number;
    SMSYeuCau:number,
    ChuQuan:number,
    Ids:string
}
export class QuyTrinhXuLy implements IQuyTrinhXuLy{
    Id:number = 0;
    IdSanPham:number=0;
    Ten:string='';
    NoiDungXuLy:string = '';
    TrangThai:number=1;
    IdCoQuan:number=0;
    TrangThaiApDung:number=0; 
    NangCap:number = 0;
    SMSYeuCau:number=0;
    NangCapN:number = -1;
    ChuQuan:number=1;
    Ids:string="";
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/quy-trinh-xu-ly/quy-trinh-xu-ly.ts